import React, { createContext } from 'react';
import { useTranslation } from "react-i18next";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const { t, i18n } = useTranslation();

    const handleChangeLanguage = (lng, lng_full, flag) => {
        i18n.changeLanguage(lng);
        localStorage.setItem("lng", lng);
        localStorage.setItem("lng_full", lng_full);
        localStorage.setItem("flag", flag);
    }

    return (
        <LanguageContext.Provider value={{ handleChangeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    )
}